<template>
  <div id="rule_page" @click="closeMenu()">
    <dd-header
      ref="menuRef"
      :headerType=2
    />
    <dd-user-rule-detial/>
  </div>
</template>
<script>
// Module
import Header from '../components/common/DcHeader'
import UseRuleDetial from '../components/common/UseRuleDetial'

export default {
  name: 'UseRule',
  components: {
    'dd-header': Header,
    'dd-user-rule-detial': UseRuleDetial
  },
  data () {
    return {
    }
  },
  methods: {
    closeMenu: function () {
      this.$refs.menuRef.close()
    }
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/input-list.scss" lang="scss" scoped></style>
<style src="../css/login.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/UseRule.vue